import React from 'react';

const formatDates = (startDate, endDate) => {
  const startDateArray = startDate.split(' ');
  const endDateArray = endDate.split(' ');
  const [endMonth, endDateNum] = endDateArray;
  const [startMonth, startDateNum] = startDateArray;

  if (startDateNum === endDateNum && startMonth === endMonth) {
    return `${startDate}`;
  } else if (endDate === undefined || endDate === '') {
    return `${startDate}`;
  } else if (endMonth !== startMonth) {
    return `${startDate} - ${endDate}`;
  } else if (startMonth === endMonth) {
    return `${startDate} - ${endDateNum}`;
  }
};

export default function FeaturedEventItem({ featuredEvent }) {
  const {
    id,
    url,
    citytown,
    event_name,
    start_date,
    end_date,
    event_description,
    the_content
  } = featuredEvent;

  const parser = new DOMParser();
  let html = parser.parseFromString(the_content, 'text/html');
  html = html.getElementsByTagName('body')[0].innerHTML;

  const truncateText = (text) => text.substring(0, 182).concat('...');

  return (
    <a className="featured-events__link" href={url}>
      <div className="featured-events__item">
        <h6>{citytown}</h6>
        <h5>{event_name}</h5>
        <p className="featured-events__date">
          {formatDates(start_date, end_date)}
        </p>
        {the_content.length > 0 ? (
          <div
            className="featured-events__description"
            dangerouslySetInnerHTML={{ __html: truncateText(html) }}
          />
        ) : (
          <p className="featured-events__description">{event_description}</p>
        )}
        <div className="line-break__hr"></div>
      </div>
    </a>
  );
}
